import Swiper from 'swiper/dist/js/swiper';

const swiperInstance = typeof Swiper === "function" && new Swiper("#swiper-carrusel_banner", {
    slidesPerView: 4,
    spaceBetween: 20,
    autoplay: {
        delay: 6500
    },
    autoHeight:false,
    preventClicks: false,
    preventClicksPropagation: false,
    preloadImages: false,
    lazy: {
        preloaderClass: 'spinner-loading',
    },
    loop: false,
    allowTouchMove: true,
    navigation: {      
        nextEl: ".swiper-carrusel_banner-btn-next ",
        prevEl: ".swiper-carrusel_banner-btn-prev "
    },
    observer: true,
    breakpoints: {
        420: {
            slidesPerView: 2,
            spaceBetween: 5,
            slidesPerGroup:2
        },
        640: {
            slidesPerView: 3,
            spaceBetween: 5,
            slidesPerGroup:3
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 5,
            slidesPerGroup:3
        },
        // when window width is <= 768px
        991: {
            slidesPerView: 3,
            spaceBetween: 5
        },
        1024: {
            slidesPerView: 4
        }
    }
});
console.log("carrusel banners")

$(".carrusel_banner").on('click', '.carrusel_video_uno', function () {
    console.log("click")
    $(".banner_video_uno").css("display", "block")
    var $video1 = $("#tipsgrid_video");
    $video1.attr("autoplay", "true");
    $video1[0].play();
 })

 $(".banner_video_uno").on("click", function (e) {
    var container_video = $("#tipsgrid_video");
    if (!container_video.is(e.target) && container_video.has(e.target).length === 0) {

       var $video1 = $("#tipsgrid_video");
       $video1.removeAttr("autoplay");
       $video1[0].pause();
       $(".banner_video_uno").css("display", "none")
    }
 })